<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasStore="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      columns: [
        { name: "EmployeeNumber" },
        { name: "EmployeeName" },
        { name: "Total" },
      ],
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getEmployeeAnalysis(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getEmployeeAnalysis(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printEmployeeAnalysis(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getEmployeeAnalysis(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
